/* eslint-disable no-dupe-keys */
export default {
  material: {
    name: '资料',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '资料名',
      charge_station: '充电站',
      material_template: '参考模板',
      attachment: '附件',
      service_provider: '运营商',
      mobile_preview: '手机预览',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      pending: '待审核',
      passed: '审核通过',
      rejected: '审核不通过'
    },
    transitions: {
      pass: '审核通过',
      reject: '拒绝'
    },
    // 占位提示
    placeholder: {
      search_keyword: '查询参考模版名'
    },
    // 详情页标签
    // 标签标题
    list_tabs: {
      all: '全部',
      pending: '待审核',
      passed: '审核通过',
      rejected: '审核不通过'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      attachment: '附件',
      process: '处理过程',
      material_template: '参考模版',
      change_state: '审核提示'
    },
    group_titles: {
      base: '基本信息',
      attachment: '附件',
      template: '参考模版'
    }
  }
}
